<template>
  <div class="teacher-page">
    <h1>教师管理页面</h1>
    <div class="teacher-info">
      <h2>欢迎，教师</h2>
      <p>这里是教师专用的管理界面</p>
    </div>
    
    <!-- 班级信息列表 -->
    <div class="class-list">
      <h3>我的班级</h3>
      <div v-if="loading" class="loading">
        <p>正在加载班级信息...</p>
      </div>
      <div v-else-if="classes.length === 0" class="empty-state">
        <p>暂无班级信息</p>
      </div>
      <div v-else class="class-items">
        <div v-for="classItem in classes" :key="classItem.id" class="class-item">
          <div class="class-info">
            <h4>{{ classItem.className }}</h4>
            <p>班级编号: {{ classItem.classNo }}</p>
            <p>学生人数: {{ classItem.studentInfoList ? classItem.studentInfoList.length : 0 }}人</p>
          </div>
          
          <!-- 学生列表 -->
          <div v-if="classItem.studentInfoList && classItem.studentInfoList.length > 0" class="student-list">
            <h5>学生列表</h5>
            <div class="student-items">
              <div v-for="student in classItem.studentInfoList" :key="student.id" class="student-item">
                <span class="student-name">{{ student.studentName }}</span>
                <span class="student-sex">{{ student.sex === 1 ? '男' : '女' }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { getTeacherClass } from '../api'
import { getToken } from '@/utils/utils'

const router = useRouter()
const classes = ref([])
const loading = ref(false)

async function fetchClassList() {
  loading.value = true
  try {
    const res = await getTeacherClass()
    if (res.data && res.data.data && res.data.data.dataList) {
      classes.value = res.data.data.dataList
    } else if (res.data && res.data.data) {
      // 如果返回的是单个对象而不是数组
      classes.value = Array.isArray(res.data.data) ? res.data.data : [res.data.data]
    }
  } catch (e) {
    console.error('获取班级信息失败:', e)
    // token失效等情况，强制重新登录
  } finally {
    loading.value = false
  }
}

onMounted(() => {
  // 检查是否已登录
  const token = getToken()
  if (!token) {
    router.replace('/login')
    return
  }
  
  // 检查是否已绑定手机号
  const bindPhoneFlag = localStorage.getItem('bindPhoneV2')
  if (bindPhoneFlag !== '1') {
    router.replace('/bindPhone')
    return
  }
  
  // 获取班级信息
  fetchClassList()
})
</script>

<style scoped>
.teacher-page {
  max-width: 600px;
  margin: 50px auto;
  padding: 20px;
  text-align: center;
}

.teacher-info {
  background: #f8f9fa;
  padding: 30px;
  border-radius: 8px;
  margin-bottom: 30px;
  border: 1px solid #e9ecef;
}

.teacher-info h2 {
  color: #333;
  margin-bottom: 10px;
}

.teacher-info p {
  color: #666;
  margin: 0;
}

.class-list {
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}

.class-list h3 {
  color: #333;
  margin-bottom: 20px;
  text-align: left;
}

.loading, .empty-state {
  text-align: center;
  padding: 40px 20px;
  color: #666;
}

.class-items {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.class-item {
  background: #f8f9fa;
  padding: 20px;
  border-radius: 6px;
  border: 1px solid #e9ecef;
  text-align: left;
}

.class-info h4 {
  color: #333;
  margin: 0 0 10px 0;
  font-size: 18px;
}

.class-info p {
  color: #666;
  margin: 5px 0;
  font-size: 14px;
}

/* 学生列表样式 */
.student-list {
  margin-top: 15px;
  padding-top: 15px;
  border-top: 1px solid #e9ecef;
}

.student-list h5 {
  color: #333;
  margin: 0 0 10px 0;
  font-size: 16px;
  font-weight: 600;
}

.student-items {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.student-item {
  background: #fff;
  padding: 6px 12px;
  border-radius: 20px;
  border: 1px solid #dee2e6;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
}

.student-name {
  color: #333;
  font-weight: 500;
}

.student-sex {
  color: #666;
  font-size: 12px;
  padding: 2px 6px;
  background: #f8f9fa;
  border-radius: 10px;
}
</style> 